// extracted by mini-css-extract-plugin
export default {"agentReviewsMobile":"agentReviewsMobile_DwI_j","slider":"slider_aQAMg","buttons":"buttons_lidRk","description":"description_i3w3l"};